import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const NewsletterService = {
  actions: {
    fetchAllNewsletters ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/newsletters',
          method: 'GET'
        })
          .then(resp => {
            const newsletters = resp.data.newsletters
            commit('api_success')
            resolve(resp)
            return newsletters
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    deleteNewsletter ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/newsletter/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    sendBulkMessageToNewsletterSubscribers ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/newsletter/send-bulk-message',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default NewsletterService



// WEBPACK FOOTER //
// ./src/services/newsletterService.js